import Trashed from '@/views/Checks/Trashed'

const routes = {
  path: '/checks/trashed',
  component: resolve => require(['../layouts/full/LayoutFull'], resolve),
  children: [
    {
      path: '/checks/trashed',
      name: 'list-checks-trashed',
      component: Trashed,
      meta: {
        pageTitle: 'Batidas Excluídas',
        is_admin: [1, '1'],
        breadcrumb: [
          {
            text: 'Batidas Excluídas',
            active: true,
          },
        ],
      },
    },
  ],
}

export default routes
